/* Utils */
import { setCursorVisibility } from '../../../providers/CursorStateProvider';

const CURSOR_SHOW = 1536;
const CURSOR_HIDE = 1537;

type CursorStateChangeEvent = {
  detail: {
    visibility: boolean
  }
};

let mouseMoveListenerAdded: boolean = false;

function handleMouseMove() {
  removeMouseMoveListener();
  setCursorVisibility(true);
}

function handleCursorStateChange(event: CursorStateChangeEvent) {
  const { detail: { visibility } } = event;
  removeMouseMoveListener();
  setCursorVisibility(visibility);
}

function handleKeydownForCursorStateChange(event: KeyboardEvent) {
  const { keyCode } = event;
  if (keyCode === CURSOR_SHOW) {
    setCursorVisibility(true);
  }

  if (keyCode === CURSOR_HIDE) {
    setCursorVisibility(false);
  }
}

function addMouseMoveListener() {
  if (!mouseMoveListenerAdded && document.body) {
    document.body.addEventListener('mousemove', handleMouseMove, false);
    mouseMoveListenerAdded = true;
  }
}

function removeMouseMoveListener() {
  if (mouseMoveListenerAdded && document.body) {
    document.body.removeEventListener('mousemove', handleMouseMove, false);
    mouseMoveListenerAdded = false;
  }
}

function addCursorStateChangeListener() {
  // @ts-expect-error -- the defined event is a custom one from the webOS platform
  document.addEventListener('cursorStateChange', handleCursorStateChange, false);
}

function addKeydownForCursorStateChangeListener() {
  document.addEventListener('keydown', handleKeydownForCursorStateChange, false);
}

export function initCursorStateListeners() {
  addMouseMoveListener();
  addCursorStateChangeListener();
  addKeydownForCursorStateChangeListener();
}
